/*
  AQUON Bundle Picker
  ===================
  The ONE interaction layer for the bundle Add-to-cart flow (snippets/
  aquon-bundle-picker.liquid). Any product-card bag (+) button marked with
  `data-aqbp-atc` (+ `data-variant-id`) opens the picker, on any page. The trigger
  is the only per-page difference; the flow, pricing, gifts and cart integration
  all live here and read the same shared config the cart engine uses.

  Flow: bag click -> Select Bundle (Pack of 1 is preselected on every open) ->
  choose flavour(s) on the flavour step (every tier shows it; the clicked
  flavour is preselected) -> add ONE pre-priced bundle line carrying the chosen
  flavours and the tier's included gift as line-item properties
  (window.AquonPurchase.build / add), then go to checkout
  (window.AquonPurchase.checkout).

  Pack of 1 is a single choice: '+' on another flavour replaces the chosen one
  (aria-pressed marks the choice and the swap is announced). Multi-pack tiers
  keep the stepper: '+' is disabled once the pack is full and a hint explains
  how to swap.
*/
(function () {
  'use strict';

  function init() {
    var picker = document.querySelector('[data-aqbp-picker]');
    if (!picker || picker.dataset.aqbpReady === '1') return;
    picker.dataset.aqbpReady = '1';
    var disposed = false;

    var addUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
    function checkoutText(key, fallback) {
      var strings = window.AquonCheckoutConfig && window.AquonCheckoutConfig.strings;
      return strings && strings[key] || fallback;
    }
    var CTA = picker.getAttribute('data-aqbp-cta') || checkoutText('continue', 'Continue to checkout');
    var NEXT_CTA = picker.getAttribute('data-aqbp-next-cta') || 'Select Flavours';

    var toast = document.querySelector('[data-aqbp-toast]');
    var toastTimer;
    var toastHideTimer;
    var toastFrame;
    function showToast(msg, isError, cartRecovery) {
      var error = picker.querySelector('[data-aqbp-purchase-error]');
      if (error) {
        error.textContent = isError ? msg : '';
        error.hidden = !isError;
        if (isError && cartRecovery) {
          var recovery = document.createElement('a');
          recovery.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          recovery.textContent = checkoutText('view_cart', 'View cart');
          error.appendChild(document.createTextNode(' '));
          error.appendChild(recovery);
        }
      }
      if (!toast) return;
      var cartLink = toast.querySelector('.aop__toast-link');
      if (cartLink) cartLink.hidden = !!isError && !cartRecovery;
      toast.querySelector('.aop__toast-text').textContent = msg;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      cancelAnimationFrame(toastFrame);
      clearTimeout(toastHideTimer);
      toastFrame = requestAnimationFrame(function () { if (!disposed) toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        toastHideTimer = setTimeout(function () { toast.hidden = true; }, 300);
      }, 3200);
    }

    var GIFTS = (window.AquonBundleFreebies && window.AquonBundleFreebies.tiers) || [];
    var bundleEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-bundle]'));
    bundleEls.forEach(function (card) {
      var tier = window.AquonPurchase.tierFor(card.getAttribute('data-bundle-variant'));
      if (!tier || tier.cents == null) return;
      card.querySelector('.apdp__bundle-price').textContent = tier.price;
      card.querySelector('.apdp__bundle-per').textContent = tier.unit + ' per sachet · ' + (tier.contents || ((tier.picks * 24) + ' sachets'));
      // Compare price and savings label from the same live variant and rule as
      // the server render (window.AquonOffer fields); with no saving the
      // rendered text is left as is.
      if (tier.compareCents > tier.cents) {
        var compareEl = card.querySelector('.apdp__bundle-price-old');
        var discountEl = card.querySelector('.apdp__bundle-discount');
        if (compareEl && tier.compareText) { compareEl.textContent = tier.compareText; compareEl.hidden = false; }
        if (discountEl && tier.percentLabel) { discountEl.textContent = tier.percentLabel; discountEl.hidden = false; }
      }
    });
    var freebieEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-freebie]'));
    var flavourEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-flavour]'));
    // The rendered 'Add one …' labels, restored whenever a multi-pack tier is shown.
    var addLabels = flavourEls.map(function (el) { return el.querySelector('[data-aqbp-inc]').getAttribute('aria-label') || ''; });
    var statusFrame = 0;
    var stepBundle = picker.querySelector('[data-aqbp-step="bundle"]');
    var stepFlavour = picker.querySelector('[data-aqbp-step="flavour"]');
    var bundleNameEl = picker.querySelector('[data-aqbp-bundle-name]');
    var countEl = picker.querySelector('[data-aqbp-count]');
    var targetEl = picker.querySelector('[data-aqbp-target]');
    var addBtn = picker.querySelector('[data-aqbp-add]');
    var nextBtn = picker.querySelector('[data-aqbp-next]');
    var nextLabel = nextBtn ? nextBtn.querySelector('.apdp__cta-text') : null;
    var selected = bundleEls.find(function (b) { return tierOf(b) === 1; }) || bundleEls[0]; // Pack of 1 is the default selection (openPicker reselects it)
    var busy = false;
    // A failed checkout can retry the confirmed cart without adding this pack again.
    var checkoutRetryItems = null;
    var purchaseTrigger = null;
    var selectionsByTier = {};
    var clickedVariantId = null; // the flavour whose bag button opened the picker

    /* Per-product pack tile images. Triggers on AQUON Our Products carry
       data-pack3-img/pack2-img/pack1-img (URLs from product metafields). When any
       are present we swap the 3 tile <img>s so the popup shows THIS product's pouch.
       Other pages (Collection) omit the attributes, so tiles stay on their default
       Tropical Punch image. Originals are cached once so switching between a
       metafield-carrying trigger and a bare one restores the defaults. */
    var packImgHosts = {
      '3': picker.querySelector('[data-aqbp-pack-img="3"]'),
      '2': picker.querySelector('[data-aqbp-pack-img="2"]'),
      '1': picker.querySelector('[data-aqbp-pack-img="1"]')
    };
    var packImgOriginals = {};
    Object.keys(packImgHosts).forEach(function (k) {
      var host = packImgHosts[k];
      if (!host) return;
      var img = host.querySelector('img');
      if (!img) return;
      packImgOriginals[k] = {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || ''
      };
    });
    function applyPackImages(btn) {
      Object.keys(packImgHosts).forEach(function (k) {
        var host = packImgHosts[k];
        if (!host) return;
        var img = host.querySelector('img');
        if (!img) return;
        var url = btn ? (btn.getAttribute('data-pack' + k + '-img') || '') : '';
        if (url) {
          img.setAttribute('src', url);
          img.removeAttribute('srcset');
        } else {
          var o = packImgOriginals[k] || { src: '', srcset: '' };
          if (o.src) img.setAttribute('src', o.src); else img.removeAttribute('src');
          if (o.srcset) img.setAttribute('srcset', o.srcset); else img.removeAttribute('srcset');
        }
      });
    }

    function picksFor(el) { return parseInt(el.getAttribute('data-flavor-picks'), 10) || 1; }
    function tierOf(el) { return parseInt(el.getAttribute('data-tier'), 10) || 0; }

    /* Gift variant ids for a tier come from the shared config, so the picker hands
       out exactly what the cart engine expects to see. */
    function giftsFor(tier) {
      var t = GIFTS.filter(function (x) { return parseInt(x.tier, 10) === tier; })[0];
      return (t && t.gifts) || [];
    }

    function selectBundle(el, reset) {
      if (busy) return;
      var previous = selected;
      var previousPicks = readFlavours();
      if (reset) selectionsByTier = {};
      else if (previous) selectionsByTier[previous.getAttribute('data-bundle-variant')] = previousPicks;
      selected = el;
      bundleEls.forEach(function (b) {
        b.classList.toggle('is-selected', b === el);
        b.setAttribute('aria-checked', b === el ? 'true' : 'false');
        b.tabIndex = b === el ? 0 : -1;
      });
      if (bundleNameEl) bundleNameEl.textContent = el.getAttribute('data-name') || '';
      var tier = tierOf(el);
      // Light the freebie tiles this tier unlocks (same unlock_for contract as the PDP)
      // and show each tile's text state, so eligibility never relies on dimming alone.
      freebieEls.forEach(function (f) {
        var list = (f.getAttribute('data-unlock-for') || '').split(',').map(function (x) { return parseInt(x.trim(), 10); });
        var included = list.indexOf(tier) !== -1;
        f.classList.toggle('is-disabled', !included);
        var includedNote = f.querySelector('[data-aqbp-freebie-included]');
        var excludedNote = f.querySelector('[data-aqbp-freebie-excluded]');
        if (includedNote) includedNote.hidden = !included;
        if (excludedNote) excludedNote.hidden = included;
      });
      if (targetEl) targetEl.textContent = String(picksFor(el));
      // Every tier continues to the flavour step.
      if (nextLabel) nextLabel.textContent = checkoutText('choose_flavours', 'Choose flavours');
      var offer = window.AquonPurchase.tierFor(el.getAttribute('data-bundle-variant'));
      if (nextBtn) nextBtn.disabled = !offer || offer.available === false;
      // Returning to a tier restores its choices. A newly visited smaller tier
      // keeps the existing choices in display order up to its capacity; the
      // larger tier's complete selection remains saved for a return visit.
      if (reset) resetFlavours(clickedVariantId);
      else applyFlavours(selectionsByTier[el.getAttribute('data-bundle-variant')] || previousPicks);
    }
    function readFlavours() {
      var picks = {};
      flavourEls.forEach(function (el) {
        picks[el.getAttribute('data-variant-id')] = Number(el.querySelector('[data-aqbp-qty]').textContent) || 0;
      });
      return picks;
    }
    function applyFlavours(picks) {
      var remaining = picksFor(selected);
      flavourEls.forEach(function (el) {
        var requested = picks[el.getAttribute('data-variant-id')] || 0;
        var quantity = el.getAttribute('data-available') === 'false' ? 0 : Math.min(requested, remaining);
        el.querySelector('[data-aqbp-qty]').textContent = String(quantity);
        remaining -= quantity;
      });
      syncCount();
    }
    function totalPicked() {
      return flavourEls.reduce(function (n, el) {
        return n + (parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0);
      }, 0);
    }
    function syncCount() {
      var total = totalPicked();
      var need = picksFor(selected);
      // A capacity-1 tier (Pack of 1) is a single choice: '+' on another flavour
      // replaces the chosen one (chooseOnly), so '+' stays enabled there. Multi-pack
      // tiers keep the stepper rule: '+' is disabled once the pack is full.
      var single = need === 1;
      var full = !single && total >= need;
      if (countEl) countEl.textContent = String(total);
      picker.setAttribute('data-aqbp-single', single ? 'true' : 'false');
      flavourEls.forEach(function (el) {
        var unavailable = el.getAttribute('data-available') === 'false';
        el.querySelector('[data-aqbp-inc]').disabled = busy || full || unavailable;
        el.querySelector('[data-aqbp-dec]').disabled = busy || Number(el.querySelector('[data-aqbp-qty]').textContent) === 0;
        el.classList.toggle('is-selected', (parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0) > 0);
        var unavailableNote = el.querySelector('[data-aqbp-unavailable]');
        if (unavailableNote) unavailableNote.hidden = !unavailable;
      });
      var hint = picker.querySelector('[data-aqbp-flavour-hint]');
      if (hint) hint.hidden = !full;
      // syncChoiceButtons (aria-pressed and labels) is defined after this block;
      // the typeof guard keeps these selection functions self-contained.
      if (typeof syncChoiceButtons === 'function') syncChoiceButtons(single);
      var offer = window.AquonPurchase.tierFor(selected.getAttribute('data-bundle-variant'));
      addBtn.disabled = busy || total !== need || !offer || offer.available === false;
      window.AquonPurchase.selectionSummary(picker.querySelector('[data-aquon-selection-summary]'), offer, total);
    }
    // Single-choice tiers: make `el` the only chosen flavour (replace, never add).
    function chooseOnly(el) {
      if (busy || el.getAttribute('data-available') === 'false') return false;
      flavourEls.forEach(function (card) {
        card.querySelector('[data-aqbp-qty]').textContent = card === el ? '1' : '0';
      });
      syncCount();
      return true;
    }
    function resetFlavours(preselectVariantId) {
      flavourEls.forEach(function (el) {
        el.querySelector('[data-aqbp-qty]').textContent = '0';
        el.classList.remove('is-selected');
      });
      if (preselectVariantId) {
        var hit = flavourEls.filter(function (el) {
          return el.getAttribute('data-variant-id') === String(preselectVariantId);
        })[0];
        if (hit && hit.getAttribute('data-available') !== 'false') hit.querySelector('[data-aqbp-qty]').textContent = '1';
      }
      syncCount();
    }
    function showStep(name) {
      stepBundle.hidden = name !== 'bundle';
      stepFlavour.hidden = name !== 'flavour';
      var heading = picker.querySelector('.apdp-flavor-modal__title');
      if (!picker.hidden && heading && name === 'flavour') {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      } else if (!picker.hidden && name === 'bundle' && selected) selected.focus({ preventScroll: true });
    }
    /* Pack of 1 '+' buttons act as single-choice toggles (aria-pressed plus a
       'Choose …' label); multi-pack tiers restore the rendered 'Add one …' label. */
    function syncChoiceButtons(single) {
      flavourEls.forEach(function (el, i) {
        var inc = el.querySelector('[data-aqbp-inc]');
        if (single) {
          var chosen = (parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0) > 0;
          inc.setAttribute('aria-pressed', chosen ? 'true' : 'false');
          inc.setAttribute('aria-label', inc.getAttribute('data-choose-label') || addLabels[i]);
        } else {
          inc.removeAttribute('aria-pressed');
          inc.setAttribute('aria-label', addLabels[i]);
        }
      });
    }
    // Polite announcement (cleared first so a repeated message is read again);
    // an empty text just clears a message that no longer applies.
    function announce(text) {
      var region = picker.querySelector('[data-aqbp-flavour-status]');
      if (!region) return;
      region.textContent = '';
      cancelAnimationFrame(statusFrame);
      if (text) statusFrame = requestAnimationFrame(function () { if (!disposed) region.textContent = text; });
    }
    function hintText() {
      var hint = picker.querySelector('[data-aqbp-flavour-hint]');
      return hint ? hint.textContent.trim() : '';
    }
    /* A control that has just become disabled must not drop focus to <body>.
       Move it to the same card's other step button, then the CTA, then the
       flavour-step heading. */
    function keepFocus(btn, card) {
      if (!btn.disabled || picker.hidden) return;
      var current = document.activeElement;
      if (current && current !== btn && current !== document.body && picker.contains(current)) return;
      var other = card.querySelector(btn.hasAttribute('data-aqbp-inc') ? '[data-aqbp-dec]' : '[data-aqbp-inc]');
      var target = [other, addBtn].filter(function (b) { return b && !b.disabled; })[0];
      if (!target) {
        target = picker.querySelector('.apdp-flavor-modal__title');
        if (target) target.tabIndex = -1;
      }
      if (target) target.focus({ preventScroll: true });
    }
    function openPicker(variantId, triggerBtn) {
      if (busy) return;
      purchaseTrigger = triggerBtn;
      clickedVariantId = variantId; // the flavour whose bag button was clicked
      applyPackImages(triggerBtn);
      picker.hidden = false;
      picker.setAttribute('aria-hidden', 'false');
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.openDialog(picker, closePicker);
      var error = picker.querySelector('[data-aqbp-purchase-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      var progress = picker.querySelector('[data-aquon-purchase-status]');
      if (progress) progress.textContent = '';
      var status = picker.querySelector('[data-aqbp-flavour-status]');
      cancelAnimationFrame(statusFrame);
      if (status) status.textContent = '';
      showStep('bundle');
      selectBundle(bundleEls.find(function (b) { return tierOf(b) === 1; }) || bundleEls[0], true);
    }
    function closePicker(force) {
      if (busy && force !== true) return;
      picker.hidden = true;
      picker.setAttribute('aria-hidden', 'true');
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.closeDialog(picker);
    }

    bundleEls.forEach(function (el) {
      el.addEventListener('click', function () { selectBundle(el); announce(''); });
    });
    if (window.AquonPurchaseUI) window.AquonPurchaseUI.radioGroup(picker.querySelector('.apdp__bundles'), '[data-aqbp-bundle]', 'is-selected');
    picker.querySelectorAll('[data-aqbp-close]').forEach(function (el) {
      el.addEventListener('click', closePicker);
    });
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        // Every tier, Pack of 1 included, picks its flavour(s) on the flavour step.
        showStep('flavour');
      });
    }
    var backBtn = picker.querySelector('[data-aqbp-back]');
    if (backBtn) backBtn.addEventListener('click', function () { if (!busy) showStep('bundle'); });
    function onEscape(e) {
      if (e.key === 'Escape' && !picker.hidden) closePicker();
    }
    document.addEventListener('keydown', onEscape);
    flavourEls.forEach(function (el) {
      var qty = el.querySelector('[data-aqbp-qty]');
      var incBtn = el.querySelector('[data-aqbp-inc]');
      var decBtn = el.querySelector('[data-aqbp-dec]');
      incBtn.addEventListener('click', function () {
        if (busy || incBtn.disabled) return;
        var current = parseInt(qty.textContent, 10) || 0;
        if (picksFor(selected) === 1) {
          // Single choice: the chosen flavour's '+' is a no-op, any other replaces it.
          if (current > 0) return;
          if (chooseOnly(el)) announce(el.getAttribute('data-selected-announcement'));
        } else {
          qty.textContent = String(current + 1);
          syncCount();
          // Say once why '+' stops working when the pack fills.
          announce(totalPicked() >= picksFor(selected) ? hintText() : '');
        }
        keepFocus(incBtn, el);
      });
      decBtn.addEventListener('click', function () {
        if (busy || decBtn.disabled) return;
        var n = parseInt(qty.textContent, 10) || 0;
        if (n > 0) qty.textContent = String(n - 1);
        syncCount();
        announce('');
        keepFocus(decBtn, el);
      });
    });

    /* Shared add-to-cart, called by the flavour-step Buy button. Builds one
       bundle line carrying the chosen flavours and the tier's included gift as
       properties. triggerBtn is the button that shows the loading spinner. */
    async function submitCart(triggerBtn) {
      if (busy || totalPicked() !== picksFor(selected)) return;
      var picks = [];
      flavourEls.forEach(function (el) {
        var qty = Number(el.querySelector('[data-aqbp-qty]').textContent);
        if (qty) picks.push({ qty: qty, variantId: Number(el.getAttribute('data-variant-id')), name: el.querySelector('[data-aqbp-flavour-name]').textContent.trim() });
      });
      var items;
      try { items = window.AquonPurchase.build(selected.getAttribute('data-bundle-variant'), picks); }
      catch (error) { showToast(error.message, true); return; }
      var itemKey = JSON.stringify(items);
      var alreadyAdded = checkoutRetryItems === itemKey;
      var buttonLabel = triggerBtn.querySelector('[data-aquon-checkout-label]');
      var progress = picker.querySelector('[data-aquon-purchase-status]');
      var errorNode = picker.querySelector('[data-aqbp-purchase-error]');
      if (errorNode) { errorNode.hidden = true; errorNode.textContent = ''; }
      function phase(message) {
        if (buttonLabel) buttonLabel.textContent = message;
        if (progress) progress.textContent = message;
      }
      busy = true;
      triggerBtn.classList.add('is-loading');
      triggerBtn.disabled = true;
      triggerBtn.setAttribute('aria-busy', 'true');
      picker.querySelectorAll('button[data-aqbp-close], button[data-aqbp-back]').forEach(function (control) { control.disabled = true; });
      syncCount();
      phase(alreadyAdded ? checkoutText('opening', 'Opening checkout…') : checkoutText('adding_pack', 'Adding your pack…'));
      try {
        if (!alreadyAdded) {
          await window.AquonPurchase.add(items);
          checkoutRetryItems = itemKey;
        }
        if (disposed) return;
        phase(checkoutText('opening', 'Opening checkout…'));
        // Release inert siblings and scroll locking before the checkout overlay opens.
        closePicker(true);
        await window.AquonPurchase.checkout({ trigger: triggerBtn, returnFocus: purchaseTrigger });
        checkoutRetryItems = null;
      } catch (error) {
        if (disposed) return;
        var needsCheckoutRetry = checkoutRetryItems === itemKey;
        if (needsCheckoutRetry && picker.hidden && !(error && error.checkoutHandled)) {
          picker.hidden = false;
          picker.setAttribute('aria-hidden', 'false');
          if (window.AquonPurchaseUI) window.AquonPurchaseUI.openDialog(picker, closePicker);
          showStep('flavour');
        }
        if (!(error && error.checkoutHandled)) showToast(needsCheckoutRetry ? checkoutText('checkout_retry', 'Your pack is in your cart. Try checkout again, or view your cart.') : ((error && error.message) || checkoutText('add_error', 'Unable to add your pack. Please try again.')), true, needsCheckoutRetry);
      } finally {
        if (disposed) return;
        busy = false;
        triggerBtn.classList.remove('is-loading');
        triggerBtn.disabled = false;
        triggerBtn.removeAttribute('aria-busy');
        if (buttonLabel) buttonLabel.textContent = CTA;
        if (progress) progress.textContent = '';
        picker.querySelectorAll('button[data-aqbp-close], button[data-aqbp-back]').forEach(function (control) { control.disabled = false; });
        syncCount();
        // A failed add keeps the dialog open; the button lost focus while it was
        // disabled, so give it back instead of leaving focus on <body>.
        var current = document.activeElement;
        if (!picker.hidden && (!current || current === document.body || !picker.contains(current))) triggerBtn.focus({ preventScroll: true });
      }
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      submitCart(addBtn);
    });

    /* Trigger: any product-card bag (+) button on the page. This is the ONLY thing
       that differs per page - the home-page card and the collection card both just
       mark their bag button with data-aqbp-atc + data-variant-id. */
    function onTrigger(event) {
      var btn = event.target.closest('[data-aqbp-atc]');
      if (!btn || !picker.isConnected) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openPicker(btn.getAttribute('data-variant-id'), btn);
    }
    document.addEventListener('click', onTrigger, true);
    function onUnload(event) {
      if (!event.target.contains(picker)) return;
      disposed = true;
      document.removeEventListener('click', onTrigger, true);
      document.removeEventListener('keydown', onEscape);
      document.removeEventListener('shopify:section:unload', onUnload);
      clearTimeout(toastTimer);
      clearTimeout(toastHideTimer);
      cancelAnimationFrame(toastFrame);
      cancelAnimationFrame(statusFrame);
      if (window.AquonPurchaseUI) window.AquonPurchaseUI.closeDialog(picker);
    }
    document.addEventListener('shopify:section:unload', onUnload);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme-editor re-renders can execute this file again: register the section-load hook once
  // per page (init itself is idempotent per picker).
  if (window.AquonBundlePickerLifecycle) return;
  window.AquonBundlePickerLifecycle = true;
  document.addEventListener('shopify:section:load', init);
})();
